import { useAppSelector } from "app/store/hook";
import DbUserTitle from "./DbUserTitle";
import DbUserRealTimePowerGen from "app/pages/db/client/DbUserRealTimePowerGen";
import DbUserDayPowerGen from "app/pages/db/client/DbUserDayPowerGen";
import EnergyConsumStatus from "app/pages/db/modules/EnergyConsumStatus";
import EnergySplyStatus from "app/pages/db/modules/EnergySplyStatus";
import GhgsEmissQnt from "app/pages/db/modules/GhgsEmissQnt";
import ElecUsageFee from "app/pages/db/modules/ElecUsageFee";

export default function DbUserMobileCustom() {
  const spinner = useAppSelector(state => state.spinner);
  return (
    <div className="container">
      <div className="dashboard-wrap">
        <DbUserTitle title="나의 대시보드" configButtonVisible={false} />
        <div className='dashboard-wrap'>
          {!spinner.loading && (
            <>
              <div className="col-wrap">
                <DbUserRealTimePowerGen />
              </div>
              <div className="col-wrap">
                <DbUserDayPowerGen />
              </div>
              <div className="col-wrap">
                <EnergyConsumStatus />
              </div>
              <div className="col-wrap">
                <EnergySplyStatus />
              </div>
              <div className="col-wrap">
                <GhgsEmissQnt />
              </div>
              <div className="col-wrap">
                <ElecUsageFee />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}